// src/validation/index.js
import { Validator } from 'vee-validate';

export function registerValidationRules() {
  Validator.extend('pakistaniPhone', {
    getMessage: (field) => `${field} must be in the format +92##########`,
    validate: (value) => !!value && /^\+92\d{10}$/.test(value) && value.length === 13,
  });

  Validator.extend('cnic', {
    getMessage: (field) => `${field} must be exactly 13 digits`,
    validate: (value) => {
      if (!value) return false;
      // Remove any non-digit characters
      const cleanValue = value.replace(/\D/g, '');
      // Check if it's exactly 13 digits
      return /^\d{13}$/.test(cleanValue);
    },
  });

  Validator.extend('ntn', {
    getMessage: (field) => `${field} must be exactly 6 digits`,
    validate: (value) => {
      if (!value) return false;
      // Remove any non-digit characters
      const cleanValue = value.replace(/\D/g, '');
      // Check if it's exactly 6 digits
      return /^\d{8}$/.test(cleanValue);
    },
  });

  // register more rules here...
}
